import React, { useEffect } from 'react'
import {Link} from "react-router-dom";
import { makeStyles } from '@material-ui/core/styles';
import { Typography, Button } from '@material-ui/core';
import { useHistory, useParams } from "react-router-dom";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';

const useStyles = makeStyles((theme) => ({
    homepageContainer:{
        padding:'10px 0 30px',
        '& h1':{
            fontSize: 32,
            color: '#007c9d',
            margin: '0 0 10px',
            '& span':{
                fontWeight: 'bold',
                color: '#fcb716',
            }
        },
        '& p':{
                margin: '0 0 20px'
        }
    },
    registerBtn: {
        textDecoration: 'none',
        padding: '10px 20px',
        width: 120,
        background: '#007c9d',
        color: '#fff',
        textAlign: 'center',
        fontWeight: '700',
        textTransform: 'uppercase',
        borderRadius: 20,
        display: 'block',
        margin: '0 auto',
        '&:hover':{
            background: '#03627b'
        }
    },
    followList:{
        padding: '0 0 20px 20px',
        '& li':{
            padding:'5px 0',

        }
    },

}))

const Home = ()=> {
    const classes = useStyles();
    const history = useHistory();
    const {id} = useParams();
    const [value, setValue] = React.useState('no');

    const handleChange = (event) => {
      setValue(event.target.value);
    };

    useEffect (()=> {
        if (value === 'yes') {
            setTimeout(()=> {
                alert(`If you’re an Apollo doctor please contact 04048217273 or mail to dr.support@apollo247.org to get on boarded`)
            }, 500)
        }
    },[value])

    const handleRegister = () => {
        history.push(`/register/${id}`)
    }
    return (
        <div className={classes.homepageContainer}>
            <Typography component="h1">Welcome to <span className={classes.bold}> Apollo 24|7</span> Doctor Partner Program! </Typography>
            <Typography component="p">We request you to please fill this form on a PC and not on your mobile. </Typography>
            <Typography component="p">Please do as follows : </Typography>
            <ul className={classes.followList}>
                <li>Click Register</li>
                <li>Fill your details in the form</li>
                <li>Upload the required documents</li>
                <li>Read Terms & Conditions</li>
                <li>Submit your form</li>
            </ul>
            <FormControl component="fieldset">
            <FormLabel component="legend">Are you a Full time Apollo doctor?</FormLabel>
            <RadioGroup aria-label="apolloDoctor" name="apolloDoctor" value={value} onChange={handleChange}>
            <FormControlLabel value="yes" control={<Radio />} label="Yes" />
            <FormControlLabel value="no" control={<Radio />} label="No" />
            </RadioGroup>
            </FormControl>
            <Button disabled={value === 'yes'} onClick={handleRegister} className={classes.registerBtn}>Register</Button>
        </div>
    )
}

export default Home